import React, { createContext, useState, useCallback } from "react";

const MessagesContext = createContext();

const MessagesProvider = ({ children }) => {
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [messageSeverity, setMessagerSeverity] = useState("info");
  const [message, setMessage] = useState("");

  const showMessage = (message, severity) => {
    setMessagerSeverity(severity);
    setMessage(message);
    setShowSnackbar(true);
  };
  const contextValue = {
    message,
    messageSeverity,
    showSnackbar,
    showMessage: useCallback(
      (message, severity) => showMessage(message, severity),
      []
    ),
    setShowSnackbar
  };

  return (
    <MessagesContext.Provider value={contextValue}>
      {children}
    </MessagesContext.Provider>
  );
};

export { MessagesContext as default, MessagesProvider };
